import { createLink } from '@tanstack/react-router';
import Button, { ButtonProps } from '@mui/material/Button';

const MUIButtonLink = (props: ButtonProps<'a'>) => <Button {...props} component="a" />;

export const RouterButtonLink = createLink(MUIButtonLink);
